module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution3_2-504a3e8377a7ee6da550c7e589446680.png";